module.exports = __webpack_public_path__ + "img/delete.23f30d9d.svg";